import { render, staticRenderFns } from "./LabelLayout.vue?vue&type=template&id=6e921e76&scoped=true&"
import script from "./LabelLayout.vue?vue&type=script&lang=js&"
export * from "./LabelLayout.vue?vue&type=script&lang=js&"
import style0 from "./LabelLayout.vue?vue&type=style&index=0&id=6e921e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e921e76",
  null
  
)

export default component.exports